import { render, staticRenderFns } from "./DialogAccessFeedback.vue?vue&type=template&id=215c95e6&scoped=true"
import script from "./DialogAccessFeedback.js?vue&type=script&lang=js&external"
export * from "./DialogAccessFeedback.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215c95e6",
  null
  
)

export default component.exports